export default __webpack_public_path__ + "static/BayswaterCarousel_0002-43acb96c931a4aaa5a202da11064e2c4.jpg";